import styled from 'styled-components'

import { useTranslation } from '../lang'

const Wrapper = styled.div`
  /* css */
  width: 100%;
  text-align: center;
  color: #999999;
  font-size: 14px;
  padding: 30px 0;
`

interface Props {
  isShow: boolean
}

const MoreInfo: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation()

  return <Wrapper>{props.isShow ? <div>{t('components.moreInfo.contents.text')}</div> : ''}</Wrapper>
}

export default MoreInfo
